export default "__VITE_ASSET__ee7df45a__"